import styled from "styled-components";
import { MediaQueries } from "ratel-ui";
import Icon from "../../../components/icon";
import Aprova180Banner from "../../../images/aprova-180-banner.png";

export const StarIcon = styled(Icon)`
  fill: #1B229F !important;
  margin-bottom: 10px;
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: block;
  background-color: #fff;
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 45px;
  width: 100%;
  max-width: 1172px;
  margin: 40px auto 0;
  padding: 0 16px;

  ${MediaQueries.mobile`
    gap: 24px;
    margin-top: 24px;
  `}
`;

export const ScoreCard = styled.div`
  background: #0a0a0a;
  border-radius: 20px;
  padding: 32px 32px 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  overflow: hidden;

  ${MediaQueries.mobile`
    padding: 24px 20px 28px;
    border-radius: 16px;
  `}
`;

export const CategoryPill = styled.div`
  background: ${({ bg }) => bg || "#f7d518"};
  border-radius: 999px;
  padding: 10px 18px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 14px;
  color: ${({ fg }) => fg || "#0a0a0a"};
  letter-spacing: 1.2px;

  svg {
    fill: ${({ fg }) => fg || "#0a0a0a"};
  }
`;

export const ScoreRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
  white-space: nowrap;

  ${MediaQueries.mobile`
    flex-direction: column;
    align-items: center;
    gap: 0;
  `}
`;

export const ScoreValue = styled.div`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 96px;
  line-height: 1;
  color: ${({ color }) => color || "#f7d518"};

  ${MediaQueries.mobile`
    font-size: 72px;
  `}
`;

export const ScoreTotal = styled.div`
  font-family: "Nunito", sans-serif;
  font-weight: 700;
  font-size: 32px;
  color: #fff;

  ${MediaQueries.mobile`
    font-size: 20px;
  `}
`;

export const ScoreSubtitle = styled.p`
  font-family: "Nunito", sans-serif;
  font-weight: 700;
  font-size: 13px;
  line-height: 1.35;
  color: rgba(255, 255, 255, 0.85);
  text-align: center;
`;

export const VideoCard = styled.div`
  background: #0e8a3e;
  border-radius: 16px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
`;

export const VideoPill = styled.div`
  background: #f7d518;
  border-radius: 999px;
  padding: 8px 14px;
  display: inline-flex;
  align-self: flex-start;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 12px;
  color: #0a0a0a;
  letter-spacing: 1px;
`;

export const VideoTitle = styled.h2`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 28px;
  line-height: 1.15;
  color: #fff;
  margin: 0;

  ${MediaQueries.mobile`
    font-size: 22px;
  `}
`;

export const VideoDescription = styled.p`
  font-family: "Nunito", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.92);
  margin: 0;

  ${MediaQueries.mobile`
    font-size: 14px;
  `}
`;

export const VideoPlayer = styled.div`
  position: relative;
  width: 100%;
  background: #0a0a0a;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  aspect-ratio: 16 / 9;
  min-height: 360px;
  overflow: hidden;

  ${MediaQueries.mobile`
    min-height: 220px;
  `}
`;

export const VideoThumb = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("/assets/thumb-craques.png") center/cover no-repeat;
  cursor: pointer;
`;

export const VideoFrame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
`;

export const VideoLabel = styled.span`
  position: absolute;
  top: 23px;
  left: 23px;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 12px;
  letter-spacing: 2px;
  color: #f7d518;
`;

export const PlayButton = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #f7d518;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: #0a0a0a;
    margin-left: 4px;
  }
`;

export const Aprova180Card = styled.div`
  background: #000;
  border: 1px solid rgba(255, 82, 39, 0.6);
  border-radius: 24px;
  box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.1);
  display: flex;
  overflow: hidden;
  min-height: 420px;

  ${MediaQueries.mobile`
    flex-direction: column;
    border-radius: 16px;
    min-height: auto;
  `}
`;

export const Aprova180Image = styled.div`
  width: 494px;
  min-width: 494px;
  background-image: url(${Aprova180Banner});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  ${MediaQueries.mobile`
    width: 100%;
    min-width: 0;
    min-height: 220px;
  `}
`;

export const Aprova180Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 36px;
  background: #000;

  ${MediaQueries.mobile`
    padding: 24px;
  `}
`;

export const Aprova180Eyebrow = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 11px;
  letter-spacing: 1.4px;
  color: #ff5227;
`;

export const EyebrowDot = styled.span`
  color: #fff;
`;

export const Aprova180Title = styled.h2`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 32px;
  line-height: 1.1;
  color: #fff;
  margin: 0;

  ${MediaQueries.mobile`
    font-size: 24px;
  `}
`;

export const Aprova180Description = styled.p`
  font-family: "Nunito", sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 1.45;
  color: #fff;
  margin: 0;
  max-width: 402px;
`;

export const BulletList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BulletItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: "Nunito", sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 1.3;
  color: #fff;
`;

export const BulletIcon = styled.div`
  width: 18px;
  height: 18px;
  min-width: 18px;
  background: #00ff88;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 11px;
`;

export const Aprova180Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  padding-top: 8px;
  margin-top: auto;

  /* lg (desktop, >= 1024px) pra cima: tudo na mesma linha */
  ${MediaQueries.desktop`
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 16px;
  `}
`;

export const CouponArea = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  ${MediaQueries.desktop`
    flex-wrap: nowrap;
  `}
`;

export const CouponBadge = styled.div`
  background: #fff;
  border: 1px dashed #ff5227;
  border-radius: 10px;
  padding: 10px 14px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  align-self: flex-start;
`;

export const CouponLabel = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 700;
  font-size: 11px;
  color: rgba(10, 10, 10, 0.7);
`;

export const CouponCode = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 15px;
  letter-spacing: 1.3px;
  color: #0a0a0a;
`;

export const CouponDiscount = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 13px;
  color: #d62828;
`;

export const CountdownChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 11px;
  letter-spacing: 0.8px;
  color: #ff2a2a;
  white-space: nowrap;

  svg {
    fill: #fff;
  }
`;

export const Aprova180CTA = styled.a`
  background: #ff5227;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 13px;
  letter-spacing: 0.8px;
  padding: 14px 22px;
  border-radius: 10px;
  box-shadow: 0px 6px 8px rgba(0, 51, 160, 0.35);
  white-space: nowrap;
  transition: transform 0.2s ease;
  text-align: center;

  &:hover {
    transform: translateY(-2px);
  }

  ${({ $disabled }) =>
    $disabled &&
    `
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
    box-shadow: none;
  `}
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

export const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  background: rgba(10, 10, 10, 0.18);
`;

export const DividerPill = styled.span`
  background: #0a0a0a;
  border-radius: 999px;
  padding: 6px 16px;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 12px;
  letter-spacing: 1.4px;
  color: #f7d518;
  white-space: nowrap;

  ${MediaQueries.mobile`
    font-size: 10px;
    letter-spacing: 1px;
    padding: 6px 12px;
  `}
`;

export const SimulatedHeader = styled.div`
  padding: 40px 96px 0;
  font-family: "Rubik", sans-serif;
  position: relative;
  @media (max-width: 767px) {
    padding: 40px 32px 0;
    text-align: center;
  }
`;

export const HeaderTitle = styled.h2`
  font-size: 1.75rem;
  font-weight: 700;
  color: #EF3900;
  letter-spacing: 0;
  margin-top: 8px;
`;

export const Logo = styled.img`
  width: 210px;
  height: 110px;
`;
